import { supabase } from './supabaseClient';

export const fetchFaq = async () => {
    const { data, error } = await supabase
        .from('faq')
        .select('*')
        .order('created_at', { ascending: true });
    
    if (error) {
        console.error('Error fetching faq:', error);
        return [];
    }
    return data;
};

export const createFaq = async (faqData) => {
    const { data, error } = await supabase
        .from('faq')
        .insert([faqData])
        .select();
    
    if (error) {
        console.error('Error creating faq:', error);
        throw error;
    }
    return data[0];
};

export const updateFaq = async (id, faqData) => {
    const { data, error } = await supabase
        .from('faq')
        .update(faqData)
        .eq('id', id)
        .select();
    
    if (error) {
        console.error('Error updating faq:', error);
        throw error;
    }
    return data[0];
};

export const deleteFaq = async (id) => {
    const { error } = await supabase
        .from('faq')
        .delete()
        .eq('id', id);
    
    if (error) {
        console.error('Error deleting faq:', error);
        throw error;
    }
};
